export const LOCALHOST_ENVIRONMENT = window.location.hostname === "localhost" || window.location.hostname.includes("192.168.");
export const DEV_ENVIRONMENT = process.env.NODE_ENV === "development";
export const PROD_ENVIRONMENT = process.env.NODE_ENV === "production";

/** Running against app.hegias-stage.com. */
export const STAGE_ENVIRONMENT = window.location.hostname.includes("hegias-stage.com");

/**
 * Anywhere that is not the live customer environment — stage or a local dev build.
 *
 * Read from the hostname rather than from NODE_ENV or REACT_APP_BASE_URL, because
 * neither of those is trustworthy here: `.env.production` currently points at
 * app.hegias-stage.com, and a production build served on stage would report itself
 * as production. The browser's own address is the only thing that always knows.
 *
 * Note that several call sites (PStreaming panels, ScenesProvider, UploadModal)
 * still test the hostname inline. Those predate this constant; new code should use
 * this one.
 */
export const NON_PRODUCTION_ENVIRONMENT = STAGE_ENVIRONMENT || LOCALHOST_ENVIRONMENT;
